import { render } from "./LatestInvoices.vue?vue&type=template&id=22439725&scoped=true"
import script from "./LatestInvoices.vue?vue&type=script&lang=js"
export * from "./LatestInvoices.vue?vue&type=script&lang=js"

import "./LatestInvoices.vue?vue&type=style&index=0&id=22439725&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22439725"]])

export default __exports__